import './contactUsSection.scss';

import { FC, useRef, useState } from 'react';
import { toast } from 'react-toastify';
import ReCAPTCHA from 'react-google-recaptcha';
import CloseIcon from '@mui/icons-material/Close';
import { Button } from '../../components/button/Button';
import AvatarGroup from '../../images/avatar-group.png';
import { Box, IconButton, Modal, TextField, Typography } from '@mui/material';

const style = {
  p: 4,
  width: 400,
  top: '50%',
  left: '50%',
  boxShadow: 24,
  border: '2px solid #000',
  bgcolor: 'background.paper',
  position: 'absolute' as 'absolute',
  transform: 'translate(-50%, -50%)',
};

const ContactUsSection = () => {
  const [modalIsOpen, setModalIsOpen] = useState(false);

  const openModal = () => setModalIsOpen(true);
  const closeModal = () => setModalIsOpen(false);

  return (
    <div className={'contact-us-section'}>
      <div className={'contact-us-section__container'}>
        <div className={'image-container'}>
          <img src={AvatarGroup} />
        </div>
        <h1>Still have questions?</h1>
        <p>Can’t find the answer you’re looking for? Please chat to our friendly team.</p>
        <Button
          type={'primary'}
          text={'CONTACT US'}
          onClick={openModal}
          classStyle="contact-us-section__container__text"
        />
      </div>
      <ContactUsModal isOpen={modalIsOpen} onRequestClose={closeModal} />
    </div>
  );
};

type Props = {
  isOpen: boolean;
  onRequestClose: () => void;
};

export const ContactUsModal: FC<Props> = ({ isOpen, onRequestClose }) => {
  const [hasRecaptchaError, setHasRecaptchaError] = useState(false);
  const [recaptchaValue, setRecaptchaValue] = useState<string | null>(null);

  const dispatchContact = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!recaptchaValue) {
      setHasRecaptchaError(true);
      return;
    }
    toast.success('Message sent successfully');
    onRequestClose();
  };

  return (
    <Modal
      open={isOpen}
      onClose={onRequestClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <IconButton
          aria-label="close"
          onClick={onRequestClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Contact Us
        </Typography>
        <Typography id="modal-modal-subtitle" variant="subtitle1" sx={{ mb: 2 }}>
          We are here to help. Please fill out the form below to get in touch with us.
        </Typography>
        <Box
          component="form"
          onSubmit={dispatchContact}
          sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}
        >
          <TextField label="Name" variant="outlined" fullWidth required />
          <TextField label="Email" type="email" variant="outlined" fullWidth required />
          <TextField label="Message" variant="outlined" fullWidth required multiline rows={4} />
          <ReCAPTCHA
            onChange={(value) => setRecaptchaValue(value)}
            sitekey="6Le1zvYpAAAAAIFP-NuGsVVJOcCXgQx4QVvpXmIt"
          />
          {hasRecaptchaError && (
            <Typography color="red" variant="caption">
              Please complete the reCAPTCHA
            </Typography>
          )}
          <Button isSubmit type={'primary'} text={'Submit'} />
        </Box>
      </Box>
    </Modal>
  );
};

export default ContactUsSection;
